<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :custom-on-row-click="showCouponDetail"
      :filter="filterItem"
      :model="model"
      :use-action="false"
      :use-default-action="false"
      :use-select="false"
      entity-name="alreadySaledVouchers"
      icon="mdi-cards"
    >
      <template #footer="{tableItems}">
        <primary-button
          icon="mdi-text-search-variant"
          text="checkAll"
          @click="showAllList"
        />
        <v-card
          :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
          class="py-2 mr-4 text-body-2"
          color="grey lighten-3 black--text"
          dark
          outlined
        >
          {{ $t('TotalSales') }}：{{ tableItems.reduce((sum, it) => sum + parseFloat(it.totalAmount), 0) | priceDisplay }} |
          {{ $t('Surplus') }}：{{ tableItems.reduce((sum, it) => sum + parseFloat(it.leftAmount), 0) | priceDisplay }}
        </v-card>
      </template>
    </ik-data-table>
    <nice-dialog v-model="showCouponDetailDialog">
      <v-container
        v-if="couponDetail"
        :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
        style="height: 98vh"
      >
        <page-header class="py-4 pb-6">
          {{ $t('vouchersUseRecord') }}
        </page-header>
        <div class="text-h5 font-weight-bold pl-2">
          {{ $t('voucherCode') }}: {{ couponDetail.longId }}
        </div>
        <span class="font-weight-regular pl-2 mt-2">{{ $t('value') }}: {{
          couponDetail.leftAmount | priceDisplay
        }}/{{ couponDetail.totalAmount | priceDisplay }}</span>

        <div class="text-body-1 pl-2">
          {{ $t('creatIn') }}: {{ couponDetail.createdAt | beautifulTime }}
        </div>
        <v-simple-table
          v-if="couponDetail.consumeLog.length>0"
          class="mt-4"
        >
          <thead>
            <tr>
              <th>{{ $t('orderNumber') }}</th>
              <th>{{ $t('time') }}</th>
              <th>{{ $t('useTheAmountOf') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="i in couponDetail.consumeLog"
              :key="i.id"
              @click="showOrder(i.orderId)"
            >
              <td>#{{ i.orderId }}</td>
              <td>{{ i.createdAt | beautifulTime }}</td>
              <td>{{ i.amount | priceDisplay }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <template v-else>
          <div class="pl-2 mt-4">
            {{ $t('Status') }}: {{ $t('noUsed') }}
          </div>
        </template>
      </v-container>
    </nice-dialog>
  </div>
</template>

<script>
import MemberCardRecord, { getCouponRecord } from '@/model/dataLayer/api/bills/CouponSalesRecord'
import PageHeader from '@/views/widget/typography/PageHeader'
import NiceDialog from '@/views/widget/uiComponent/NiceDialog'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import PrimaryButton from '@/views/AadenPages/components/PrimaryButton.vue'

export default {
  name: 'VoucherStatistic',
  components: {
    PrimaryButton,
    PageHeader,
    NiceDialog,
    IkDataTable
  },
  data () {
    return {
      showAll: true,
      model: MemberCardRecord,
      couponDetail: null,
      loading: false,
      showCouponDetailDialog: null
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val, oldVal) {
        if (oldVal) {
          this.showAll = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    filterItem () {
      return { dateFilter: this.$parent.dateRange, showAll: this.showAll }
    }
  },
  methods: {
    showAllList () {
      this.showAll = true
    },
    async showCouponDetail (coupon) {
      this.couponDetail = await getCouponRecord(coupon.id)
      this.showCouponDetailDialog = true
    }
  }
}
</script>

<style scoped>

</style>
